<template>
  <div class="entra-page">
    <EntraPageHeader
      title="Intune — Devices"
      :tenantDisplayName="tenantName"
      :primaryDomain="primaryDomain"
      :regionCode="regionCode"
      :tenantStatus="tenantStatus"
      :freshnessState="freshnessState"
      :lastCollection="lastCollection"
      :dataCompleteness="dataCompleteness"
      :capabilities="capabilities"
      :showSearch="false"
      :showExport="false"
      @refresh="loadData"
    />

    <div class="page-body">
      <div v-if="error" class="error-banner">{{ error }}</div>
      <div v-if="tableState === 'loading'" class="loading-block">Loading devices...</div>
      <div v-else-if="devices.length === 0" class="empty-block">No managed devices found in this tenant.</div>
      <div v-else class="tab-content">
        <table class="data-table">
          <thead><tr><th>Device</th><th>OS</th><th>Compliance</th><th>Last Sync</th></tr></thead>
          <tbody>
            <tr v-for="d in devices" :key="d.deviceId">
              <td class="cell-name">{{ d.deviceName || d.deviceId }}</td>
              <td>{{ d.osVersion || '--' }}</td>
              <td><span class="pill" :class="d.complianceState === 'compliant' ? 'pill-ok' : 'pill-warn'">{{ d.complianceState || 'unknown' }}</span></td>
              <td class="date-cell">{{ formatDate(d.lastSyncDateTime) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import EntraPageHeader from '@/components/entra/common/EntraPageHeader.vue';
import { getEntraIntune, getEntraTenantSummary, getEntraTenantCapabilities } from '@/services/entra-api.js';
import { getCapabilityStateLabel } from '@/services/entra-utils.js';

export default {
  name: 'EntraIntuneDevices',
  components: { EntraPageHeader },
  data: function() {
    return {
      tenantId: '', tenantName: '', primaryDomain: '', regionCode: '', tenantStatus: '',
      freshnessState: 'fresh', lastCollection: '', dataCompleteness: null, capabilities: [],
      devices: [], tableState: 'loading', error: ''
    };
  },
  methods: {
    formatDate: function(ts) {
      if (!ts) return '--';
      try { return new Date(ts).toLocaleDateString(); } catch(e) { return '--'; }
    },
    loadData: function() {
      var self = this;
      this.tenantId = this.$route.params.tenantId || '';
      if (!this.tenantId) { this.error = 'Please select a tenant first.'; return; }
      getEntraTenantSummary(this.tenantId).then(function(data) {
        var t = data.tenant || data;
        self.tenantName = t.displayName || ''; self.primaryDomain = t.primaryDomain || '';
        self.regionCode = t.regionCode || ''; self.tenantStatus = t.status || '';
        self.lastCollection = t.lastSuccessfulCollectionAt || '';
      }).catch(function() {});
      getEntraTenantCapabilities(this.tenantId).then(function(data) {
        self.capabilities = (data || []).map(function(c) { return { key: c.capabilityKey, state: c.state, stateLabel: getCapabilityStateLabel(c.state) }; });
      }).catch(function() {});

      getEntraIntune(this.tenantId).then(function(d) {
        self.devices = d.devices || [];
        self.tableState = 'loaded';
      }).catch(function(err) { self.error = err.message; });
    }
  },
  mounted: function() { this.loadData(); },
  watch: { '$route.params.tenantId': 'loadData' }
};
</script>

<style scoped>
.entra-page { min-height: 100%; background: #F0F9FF; }
.page-body { padding: 20px 24px; }
.error-banner { padding: 12px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 6px; color: #991b1b; font-size: 0.8125rem; margin-bottom: 16px; }
.loading-block { padding: 48px; text-align: center; color: #94a3b8; }
.empty-block { padding: 48px; text-align: center; color: #94a3b8; font-size: 0.875rem; }
.tab-content { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; }
.data-table { width: 100%; border-collapse: collapse; font-size: 0.8125rem; }
.data-table th { background: #f8fafc; color: #475569; font-weight: 600; text-align: left; padding: 10px 14px; border-bottom: 2px solid #e2e8f0; white-space: nowrap; }
.data-table td { padding: 9px 14px; border-bottom: 1px solid #f1f5f9; color: #334155; }
.data-table tbody tr:hover { background: #F0F9FF; }
.cell-name { font-weight: 600; color: #0C4A6E; }
.date-cell { font-size: 0.75rem; color: #64748b; white-space: nowrap; }
.pill { font-size: 0.6875rem; font-weight: 600; padding: 2px 8px; border-radius: 4px; text-transform: capitalize; }
.pill-ok { background: #dcfce7; color: #047857; }
.pill-warn { background: #fef3c7; color: #92400e; }
</style>
